import { useEntityUrl } from 'framework/routing';
import { useProjectUrl } from 'domain/shared/project';

export const PROJECT_DASHBOARD_PATH = '/dashboard';

export const useProjectDashboardUrl = () => {
  const { getSingleEntityUrl } = useProjectUrl();
  const projectLink = getSingleEntityUrl();
  const listUrl = `${projectLink}${PROJECT_DASHBOARD_PATH}`;
  const baseUrls = useEntityUrl({
    baseLink: listUrl,
  });

  return {
    ...baseUrls,
    getListUrl: () => listUrl,
  };
};
